// extracted by mini-css-extract-plugin
export default {"box__select":"customSelect_box__select__7eKhW","box__option":"customSelect_box__option__qev4t"};